import {
	AllowedDetailsTabEnum,
	ProductEnum
} from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
} from '@core/interfaces/route.interface';


export enum MyAccountRoutesEnum {
	Page = '',
	PageProduct = ':product',

	PageProductContract = ':product/contracts',

	PageProductViewContractDetail = ':product/view/contracts/:contractId',
	PageProductViewContractDetailTab = ':product/view/contracts/:contractId/:tab',

	PageProductContractDetail = ':product/contracts/:contractId',
	PageProductContractDetailTab = ':product/contracts/:contractId/:tab',

	PageProductContractFormPageUpdate = ':product/contracts/:contractId/update',

	PageProductContractUsage = ':product/contracts/:contractId/usage/:usagePeriod',
}

// My Account Routes ####################################################################
export interface MyAccountProductRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProduct;

	params: { product: ProductEnum };
}


// MyAccount Contract Routes ##############################################################
export interface MyAccountProductContractsRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProductContract;

	params: {
		product: ProductEnum
	};

	replaceLastStoredRouteWithNew: boolean;
}


// Contract Detail ---------
// view
export interface MyAccountProductViewContractDetailRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProductViewContractDetail;

	params: {
		contractId: string,
		product: ProductEnum
	};
}

export interface MyAccountProductViewContractDetailTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProductViewContractDetailTab;

	params: {
		contractId: string,
		product: ProductEnum,
		tab: AllowedDetailsTabEnum
	};

	replaceLastStoredRouteWithNew: boolean;
}

// page
export interface MyAccountProductContractDetailRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProductContractDetail;

	params: {
		product: ProductEnum,
		contractId: string
	};
}

export interface MyAccountProductContractDetailTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProductContractDetailTab;

	params: {
		product: ProductEnum,
		contractId: string,
		tab: AllowedDetailsTabEnum
	};

	replaceLastStoredRouteWithNew: boolean;
}


// Contract Form
export interface MyAccountProductContractFormPageUpdateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProductContractFormPageUpdate;

	params: {
		product: ProductEnum,
		contractId: string
	};
}

// Contract Usage
export interface MyAccountProductContractUsageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.MyAccount;

	path: MyAccountRoutesEnum.PageProductContractUsage;

	params: {
		product: ProductEnum,
		contractId: string,
		usagePeriod: string
	};
}
